import React from "react";
import { CustomerAppAffiliateTaskView } from "./CustomerAppAffiliateTaskView";
import { CustomerAppStandardTaskView } from "./CustomerAppStandardTaskView";
import { useCheckoutContext } from "checkout/providers/CheckoutContext";
import { isIntegratedPartner } from "checkout/util/roles";

const CustomerAppTaskView: React.FC = () => {
  const { splatRole } = useCheckoutContext();

  if (isIntegratedPartner(splatRole)) {
    return <CustomerAppAffiliateTaskView />;
  }

  return <CustomerAppStandardTaskView />;
};

export { CustomerAppTaskView };
